/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetCustomersRequestPayloadExportCsv } from '../../models/get-customers-request-payload-export-csv';

export interface PostApiCustomerV1Export$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: GetCustomersRequestPayloadExportCsv
}

export function postApiCustomerV1Export$Json(http: HttpClient, rootUrl: string, params?: PostApiCustomerV1Export$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, postApiCustomerV1Export$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

postApiCustomerV1Export$Json.PATH = '/private/v1/customers/export';
